import { render, staticRenderFns } from "./DocumentAppointmentTabContent.vue?vue&type=template&id=1de05cbd&"
import script from "./DocumentAppointmentTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentAppointmentTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAppointmentTabContent.vue?vue&type=style&index=0&id=1de05cbd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports